import React, {useEffect, useState} from "react"
import { Div, Text, Container } from "atomize";
import styled from "styled-components";
import Header from "../Components/Molecules/Header";
import Routes from "../Routes";
import {apiGet} from "../Api";
import Paragraph from "../Components/Paragraphs";
import {bindActionCreators} from "redux";
import {addActivity} from "../redux/actions";
import theme from './../Theme/Theme';
import { connect } from "react-redux";
import SEO from "../Components/Atoms/SEO";
import ReactGA from 'react-ga';


const Wrapper = styled(Div)`
  background-color: ${props => props.skew === "true" ? theme.colors.alphaPrimary : 'unset'};
  // background-image: ${props => props.skew === "true" ? theme.colors.alphaPrimaryGradient : 'unset'};
  transform: ${props => props.skew === "true" ? 'skewY(4deg)' : 'none'};
  padding: 2rem 0;
  > div {
    transform: ${props => props.skew === "true" ? 'skewY(-4deg)' : 'none'};
  }
`;

function Overview(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [data, setData] = useState({});
  const [heroImgUrl, setHeroImgUrl] = useState(null);
  const [paragraphs, setParagraphs] = useState([]);

  const page = Routes.filter( route => {
    return route.path === props.location.pathname
  });

  let pageTitle = '';

  if (page.length > 0) {
    pageTitle = page[0].name;
  }

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/page?filter[title]=${pageTitle}&include=field_banner_image`);
      setData(result.data);
      setHeroImgUrl(result.data.included[0].attributes.uri.url);
      setParagraphs(result.data.data[0].relationships.field_paragaphs.data)
    }
    fetchData();

    async function loadActivities() {
      const urlParams = new URLSearchParams(window.location.search);
      if(urlParams.get('activities')) {
        let loadActivities = urlParams.get('activities').split(",");
        for (let i = 0; i < loadActivities.length; i++) {
          const result = await apiGet(`/node/activity/${loadActivities[i]}?include=field_banner_image,field_experience_layer,field_activity_type,field_materials,field_video&jsonapi_include=1`);
          props.addActivity(result.data.data)
        }
      }
    }
    loadActivities()

  }, []);

  return (
    <Div>
      <SEO
        title={"Overview | Engineering for Humanity | Olin College of Engineering"}
        description={data && data.field_description ? data.field_description : null}
      />
      <Header
        pageTitle={pageTitle}
        heroImgUrl={heroImgUrl}
        height={250}
      />
      <Div
        style={{ marginTop: '-16rem' }}
      >
        {
          paragraphs.map( (paragraph, i) => {
              return (
                <Wrapper
                  key={paragraph.id}
                  skew={ i%2 === 0 && i !== 0 ? "true" : "false"}
                >
                  <Container
                    style={{ overflowX: 'hidden', paddingBottom: '30px' }}
                  >
                    <Paragraph
                      type={paragraph.type}
                      id={paragraph.id}
                    />
                  </Container>
                </Wrapper>
              )
            })
        }
      </Div>
    </Div>
  )
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addActivity: addActivity
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(Overview);
